import {RootState} from "../store";
import {createSelector} from "reselect";
import {EnumPages} from "../../enums/EnumPages";

export const getTexts = (state: RootState) => {
    return state.appReducer.pagesText
}

export const getTextsAbout = createSelector(getTexts, texts => {
    return texts.filter(text => text.page === EnumPages.about)
})